var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        [
          _vm._v(
            _vm._s(_vm.$t("settingLogisticsStrategyConfig.logisticsStrategy")) +
              " "
          ),
          [
            _c("span", { staticClass: "text-muted font12 ml0" }, [
              _vm._v(
                "* " +
                  _vm._s(
                    _vm.$t(
                      "settingLogisticsStrategyConfig.logisticsStrategyText"
                    )
                  )
              ),
            ]),
          ],
        ],
        2
      ),
      _c(
        "draggable",
        {
          attrs: {
            "ghost-class": "ghost",
            "chosen-class": "chosen",
            "force-fallback": "true",
            group: "people",
            animation: "300",
            filter: ".forbid",
            disabled: _vm.disabled,
            draggable: ".item",
          },
          on: { start: _vm.onStart },
          model: {
            value: _vm.list,
            callback: function ($$v) {
              _vm.list = $$v
            },
            expression: "list",
          },
        },
        _vm._l(_vm.list, function (item) {
          return _c(
            "div",
            { key: item.typeCode, staticClass: "item" },
            [
              _c(
                "div",
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "settingLogisticsStrategyConfig." + item.typeCode
                        )
                      ) +
                      " "
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "ml20",
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          return _vm.onView(item)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.text))]
                  ),
                ],
                1
              ),
              _c("el-switch", {
                staticClass: "switch",
                model: {
                  value: item.enabledFlag,
                  callback: function ($$v) {
                    _vm.$set(item, "enabledFlag", $$v)
                  },
                  expression: "item.enabledFlag",
                },
              }),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.defaultLogistics } },
        [
          _c("BjDivider", [
            _vm._v(
              _vm._s(_vm.$t("settingLogisticsStrategyConfig.logisticsSettings"))
            ),
          ]),
          _c(
            "el-form-item",
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.logisticsSetting,
                    callback: function ($$v) {
                      _vm.logisticsSetting = $$v
                    },
                    expression: "logisticsSetting",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("settingLogisticsStrategyConfig.freightRadio")
                      )
                    ),
                  ]),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("settingLogisticsStrategyConfig.priorityRadio")
                      )
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "BjDivider",
            [
              _vm._v(
                _vm._s(
                  _vm.$t("settingLogisticsStrategyConfig.defaultLogistics")
                ) + " "
              ),
              [
                _c("span", { staticClass: "text-muted font12 ml0" }, [
                  _vm._v(
                    "* " +
                      _vm._s(
                        _vm.$t(
                          "settingLogisticsStrategyConfig.defaultLogisticsText"
                        )
                      )
                  ),
                ]),
              ],
            ],
            2
          ),
          _c(
            "el-descriptions",
            {
              attrs: {
                title: "",
                direction: "vertical",
                column: 4,
                border: "",
              },
            },
            [
              _c(
                "el-descriptions-item",
                {
                  attrs: {
                    "label-style": { "text-align": "center" },
                    "content-style": { "text-align": "center" },
                    label: _vm.$t(
                      "settingLogisticsStrategyConfig.table.logisticsProviderName"
                    ),
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "companyId",
                        rules: _vm.rules.logisticsProviderName,
                      },
                    },
                    [
                      _c("BjSelectLogisticCompany", {
                        staticStyle: { width: "200px !important" },
                        attrs: {
                          "default-options": {
                            label: _vm.defaultLogistics.companyName,
                            value: _vm.defaultLogistics.companyId,
                          },
                          clearable: "",
                        },
                        on: { change: _vm.changeCompanyId },
                        model: {
                          value: _vm.defaultLogistics.companyId,
                          callback: function ($$v) {
                            _vm.$set(_vm.defaultLogistics, "companyId", $$v)
                          },
                          expression: "defaultLogistics.companyId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions-item",
                {
                  attrs: {
                    "label-style": { "text-align": "center" },
                    "content-style": { "text-align": "center" },
                    label: _vm.$t(
                      "settingLogisticsStrategyConfig.table.businessName"
                    ),
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "businessId",
                        rules: _vm.rules.businessName,
                      },
                    },
                    [
                      _c("BjSelectLogisticBusiness", {
                        staticStyle: { width: "200px !important" },
                        attrs: {
                          disabled: !_vm.defaultLogistics.companyId,
                          "default-params": _vm.defaultParams,
                          "default-options": {
                            label: _vm.defaultLogistics.businessName,
                            value: _vm.defaultLogistics.businessId,
                          },
                          placeholder: _vm.defaultLogistics.companyId
                            ? _vm.$t(
                                "settingLogisticsStrategyConfig.selectDesignatedLogisticsBusiness"
                              )
                            : _vm.$t(
                                "settingLogisticsStrategyConfig.selectDesignatedLogisticsProvider"
                              ),
                          clearable: "",
                        },
                        model: {
                          value: _vm.defaultLogistics.businessId,
                          callback: function ($$v) {
                            _vm.$set(_vm.defaultLogistics, "businessId", $$v)
                          },
                          expression: "defaultLogistics.businessId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions-item",
                {
                  attrs: {
                    "label-style": { "text-align": "center" },
                    "content-style": { "text-align": "center" },
                    label: _vm.$t(
                      "settingLogisticsStrategyConfig.table.packageBilling"
                    ),
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "amount",
                        rules: _vm.rules.packageBilling,
                      },
                    },
                    [
                      _c("BjInputMoney", {
                        staticStyle: { width: "200px !important" },
                        scopedSlots: _vm._u([
                          {
                            key: "append",
                            fn: function () {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "settingLogisticsStrategyConfig.pricePackage"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.defaultLogistics.amount,
                          callback: function ($$v) {
                            _vm.$set(_vm.defaultLogistics, "amount", $$v)
                          },
                          expression: "defaultLogistics.amount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-default-width mt16",
                  attrs: { type: "primary" },
                  on: { click: _vm.onSubmit },
                },
                [_vm._v(_vm._s(_vm.$t("saveText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }